module.exports = __webpack_public_path__ + "img/article-logo.d7094b52.png";